import { render, staticRenderFns } from "./addressData.vue?vue&type=template&id=0d261ed6&"
import script from "./addressData.vue?vue&type=script&lang=js&"
export * from "./addressData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "addressData.vue"
export default component.exports